import { handleActions } from 'redux-actions';

import { normalizeBy } from 'utils';

import * as types from './actionTypes';

export const initialState = {
	dataChanged: false,
	originalData: [],
	additionalData: [],
	activeKeys: [],
	inactiveKeys: [],
};

const setInitialData = (data) => {
	const activeData = data.filter((item) => item.description.length);
	const inactiveData = data.filter((item) => !item.description.length);

	return {
		dataChanged: false,
		originalData: data,
		additionalData: normalizeBy(data, 'key'),
		activeKeys: activeData.map((item) => item.key),
		inactiveKeys: inactiveData.map((item) => item.key),
	};
};

const reducerMap = {
	[types.SET_CAMPAIGN_ADDITIONAL_DATA]: (state, { payload }) => {
		const { data } = payload;

		return setInitialData(data);
	},
	[types.REVERT_CHANGES]: (state) => {
		return setInitialData(state.originalData);
	},
	[types.UPDATE_CAMPAIGN_ADDITIONAL_DATA]: (state, { payload }) => {
		return {
			...state,
			dataChanged: true,
			activeKeys: payload.data.map((item) => item.key),
			inactiveKeys: state.inactiveKeys.filter((key) => key !== payload.key),
		};
	},
	[types.EDIT_DATA]: (state, { payload }) => {
		const { key, text } = payload;

		return {
			...state,
			dataChanged: true,
			additionalData: {
				...state.additionalData,
				[key]: {
					...state.additionalData[key],
					description: text,
				},
			},
		};
	},
	[types.DISCARD_DATA]: (state, { payload }) => {
		return {
			...state,
			dataChanged: true,
			additionalData: {
				...state.additionalData,
				[payload.key]: {
					...state.additionalData[payload.key],
					description: '',
				},
			},
			activeKeys: state.activeKeys.filter((key) => key !== payload.key),
			inactiveKeys:
				state.additionalData[payload.key].changeType === 'NEW' // permanently discard
					? state.inactiveKeys
					: state.inactiveKeys.concat(payload.key),
		};
	},
	[types.ACTIVATE_DATA]: (state, { payload }) => {
		return {
			...state,
			dataChanged: true,
			activeKeys: [...state.activeKeys, payload.key],
			inactiveKeys: state.inactiveKeys.filter((key) => key !== payload.key),
		};
	},
};

export default handleActions(reducerMap, initialState);
